import { Component, OnInit } from '@angular/core';
import { SessionTileParams } from '../../_models/session';
import { UserService, SessionService } from '../../_services/index';
import { ActionParams } from '../../_models/actions';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { Router } from '@angular/router';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';
import { AuthenticationStateHelperService } from '../../_helpers/authentication-state-helper/authentication-state-helper.service';

@Component({
    selector: 'tutor-landing-page',
    templateUrl: './tutor.landing.component.html',
    standalone: false
})


export class TutorLandingComponent implements OnInit {

  sessionTileParams: SessionTileParams = new SessionTileParams();
  actionDataParams: ActionParams = new ActionParams();

  constructor(
    private userService: UserService,
    private sessionService: SessionService,
    public media: MediaObserver,
    public router: Router,
    private featureHelperService: FeatureHelperService,
    private authenticationStateHelper: AuthenticationStateHelperService

  ) { }

  ngOnInit() {
    
    let featureList = new Array<string>();
    featureList.push("TutorHomeView");

    let currentUserFeatures = this.featureHelperService.checkFeaturePermissions(featureList);

    if (!currentUserFeatures.filter(f => f.feature === "TutorHomeView")[0].enabled) {
      console.error("User does not have the required permissions to view the tutor landing screen");
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      this.authenticationStateHelper.unauthorizedToken = true;
    }

    var today = new Date();
    this.sessionService.getSessionTileDates(today);
    this.sessionTileParams = this.sessionService.sessionDataParamToday;
    this.sessionTileParams.sessionHeader = "Sessions Today";
    this.sessionTileParams.navigateToAddSession = true;
  }
}
